import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { ADPComponentsModule, ADPResourceService } from 'digital-core';
import { AriaLabelDirective } from 'src/app/shared/directives';
import { ModalWindowComponent } from '../modal-window/modal-window.component';

/**
 * Informational modal shown before handing a user whose coverage has ended off to the
 * GSSP service/claims portal. It warns that coverage only applies to issues that occurred
 * before coverage ended, then lets the user continue. Closes with `true` when the user
 * chooses to continue, `undefined` otherwise.
 */
@Component({
  selector: 'app-coverage-ended-service-modal',
  templateUrl: './coverage-ended-service-modal.component.html',
  styleUrl: './coverage-ended-service-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ADPComponentsModule, ModalWindowComponent, MatButtonModule, MatDialogClose, MatIcon, AriaLabelDirective],
})
export class CoverageEndedServiceModalComponent {
  private readonly dialogRef = inject<MatDialogRef<CoverageEndedServiceModalComponent, boolean>>(MatDialogRef);
  private readonly resourceService = inject(ADPResourceService);

  protected readonly descriptionContext = { phoneNumber: this.resourceService.getViewLabel('Global_PhoneNumber') };

  protected onContinue(): void {
    this.dialogRef.close(true);
  }
}
